import { render } from "./ProductDetail.vue?vue&type=template&id=0fa35f2a&scoped=true&ts=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"

import "./ProductDetail.vue?vue&type=style&index=0&id=0fa35f2a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa35f2a"]])

export default __exports__